import { useCallback } from 'react';

import {
  ControlButton,
  ControlButtonProps,
} from '@/components/diagrams/FlowChart/components/Controls/ControlButton';
import { useIsInteractive } from '@/components/diagrams/FlowChart/hooks/useIsInteractive';
import { MagicWand01Icon } from '@/components/icons/MagicWand01Icon';

import { useEntityDiagramContext } from '../contexts/entityDiagram.context';

export type AutoPositionButtonProps = Omit<ControlButtonProps, 'onClick'>;

export const AutoPositionButton = ({
  children,
  ...props
}: AutoPositionButtonProps) => {
  const { isInteractive } = useIsInteractive();
  const { dispatch } = useEntityDiagramContext();

  const handleClick = useCallback(() => {
    dispatch({ type: 'AUTO_POSITION' });
  }, [dispatch]);

  if (!isInteractive) return null;

  return (
    <ControlButton
      variant="secondary"
      onClick={handleClick}
      title="Auto position tiles"
      aria-label="Auto position tiles"
      startIcon={MagicWand01Icon}
      {...props}
    >
      {children ?? <>Auto position tiles</>}
    </ControlButton>
  );
};
